export default class RoutingService {
    static readonly startQueryChar: string = "?";
    static readonly querySeparator: string = "&";

    public static getMainPageRoute(): string {
        return `/`;
    }

    public static getPriceListPageRoute(): string {
        return `/#cennik`;
    }
    
    public static getPasswordChangePageRoute(): string {
        return `/passwordChange/`;
    }

    public static getPasswordChangeRoute(token: string): string {
        return `/passwordChange/${this.startQueryChar}token=${token}`;
    }

    public static getForCompaniesPageRoute(): string {
        return `/dla-firm/`;
    }

    public static getTermsPageRoute(): string {
        return `/regulaminy/`;
    }

    public static getLogInPageRoute(): string {
        return `/zaloguj/`;
    }

    public static getSignUpPageRoute(): string {
        return `/zarejestruj/`;
    }

    public static getUserAccountStatusPageRoute(): string {
        return `/konto/status/`;
    }

    public static getNewsletterLandingPageRoute(): string {
        return `/newsletter/`;
    }
}